import { render, staticRenderFns } from "./modal_participants_publications.vue?vue&type=template&id=783765a0&scoped=true"
import script from "./modal_participants_publications.vue?vue&type=script&lang=js"
export * from "./modal_participants_publications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783765a0",
  null
  
)

export default component.exports